// extracted by mini-css-extract-plugin
export default {"textContainer":"blogPage_textContainer__gCINZ"};